import React from 'react';

const titileCase = title => {
  return title.substr(0, 1).toUpperCase() + title.substr(1).toLowerCase();
};

export default titileCase;
